import { API_URL } from '@/config';
import i18n from '@/lib/i18n/config';
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const httpLink = createHttpLink({
  uri: `${API_URL}/api/v1/graphql`,
  credentials: 'include',
});

const langLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      'Accept-Language': i18n.language,
    },
  };
});

export const apolloClient = new ApolloClient({
  link: langLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      ActiveArticle: {
        keyFields: ['code'],
      },
      DeletedArticle: {
        keyFields: ['code'],
      },
    },
  }),
});
